# Models Worth Trying

**DeepSeek R1-0528-Qwen3-8B**

Distilled reasoning model with chain-of-thought capabilities — achieves state-of-the-art performance on AIME 2024, matching Qwen3-235B

**Gemma 3n E4B**

Google's efficient 4B parameter model with multimodal support — runs with only ~4GB memory footprint using selective parameter activation

**Devstral Small 2507**

Mistral's 24B parameter coding agent specialist — #1 open-source model on SWE-Bench Verified (53.6%), excels at multi-file editing

**Qwen3-4B-Instruct-2507**

Alibaba's 4B parameter model with 256K context window — strong multilingual support (100+ languages), excellent instruction-following

All run smoothly on M1 Macs with 32GB RAM